import React from 'react';
import { DURATION_FILTERS } from '../ticketConstants';
import { toLocalInput } from '../ticketUtils';
import { useLang } from '../i18n';

export function CompletedFilters({ filters, setFilters, totalCount, filteredCount }) {
  const { t } = useLang();
  const now = new Date();
  const todayS = toLocalInput(new Date(now.getFullYear(), now.getMonth(), now.getDate(), 0, 0, 0));
  const todayE = toLocalInput(new Date(now.getFullYear(), now.getMonth(), now.getDate(), 23, 59, 59));

  return (
    <div className="kds__cf">
      <div className="kds__cf-row">
        <div className="kds__cf-group">
          <span className="kds__cf-label">{t('cf.duration')}</span>
          <div className="kds__cf-chips">
            {DURATION_FILTERS.map(f => (
              <button key={f.key}
                className={`kds__cf-chip${filters.duration === f.key ? ' kds__cf-chip--on' : ''}`}
                onClick={() => setFilters(p => ({ ...p, duration: f.key }))}>
                {f.key === 'all' ? t('cf.all') : f.label}
              </button>
            ))}
          </div>
        </div>

        <div className="kds__cf-group">
          <span className="kds__cf-label">{t('cf.orderType')}</span>
          <div className="kds__cf-chips">
            {['all', 'togo', 'online', 'other'].map(k => (
              <button key={k}
                className={`kds__cf-chip${filters.type === k ? ' kds__cf-chip--on' : ''}`}
                onClick={() => setFilters(p => ({ ...p, type: k }))}>
                {t(`cf.type.${k}`)}
              </button>
            ))}
          </div>
        </div>

        <div className="kds__cf-group">
          <span className="kds__cf-label">{t('cf.sortLabel')}</span>
          <div className="kds__cf-chips">
            {['newest', 'oldest', 'fastest', 'slowest'].map(k => (
              <button key={k}
                className={`kds__cf-chip${filters.sort === k ? ' kds__cf-chip--on' : ''}`}
                onClick={() => setFilters(p => ({ ...p, sort: k }))}>
                {t(`cf.sort.${k}`)}
              </button>
            ))}
          </div>
        </div>
      </div>

      <div className="kds__cf-row kds__cf-row--date">
        <div className="kds__cf-group">
          <span className="kds__cf-label">{t('drp.from')}</span>
          <input type="datetime-local" className="kds__cf-input"
            value={filters.dateFrom || todayS}
            onChange={e => setFilters(p => ({ ...p, dateFrom: e.target.value }))} />
        </div>
        <div className="kds__cf-group">
          <span className="kds__cf-label">{t('drp.to')}</span>
          <input type="datetime-local" className="kds__cf-input"
            value={filters.dateTo || todayE}
            onChange={e => setFilters(p => ({ ...p, dateTo: e.target.value }))} />
        </div>
        <div className="kds__cf-group kds__cf-group--reset">
          <button className="kds__cf-reset" onClick={() => setFilters({ duration: 'all', type: 'all', sort: 'newest', dateFrom: '', dateTo: '' })}>{t('cf.reset')}</button>
          <span className="kds__cf-count">{t('cf.count', { n: filteredCount, total: totalCount })}</span>
        </div>
      </div>
    </div>
  );
}
